<template>
  <div class="style-selection">
    <div class="style-selection-container">
      <div class="style-selection-container-img">
        <img :src="require(`@/assets/img/order-steps/frames/${style}-${view}.jpg`)" alt="design" />
      </div>
      <div>
        <div class="style-selection-list">
          <div class="style-selection-option">
            <h3 class="style-selection-title">
              <img class="public-sidebar--content-button-img" src="@/assets/img/icons/brush.svg" alt="brush icon" />
              Select interior style
            </h3>
            <div class="style-selection-container-styles">
              <CustomSelect :lang="lang"
              :value="style" :options="interiorStyleList" @update:value="setStyle" :change-handler="setStyle" />
            </div>
          </div>

          <div class="style-selection-option">
            <h3 v-if="tariff !== 1" class="style-selection-title">
              <img class="public-sidebar--content-button-img" src="@/assets/img/icons/image.svg" alt="image icon" />
              Select a window view
            </h3>
            <div v-if="tariff !== 1" class="style-selection-container-views">
              <CustomSelect :lang="lang" :value="view" @update:value="setView" :options="windowViewList" :change-handler="setView" />
            </div>
          </div>
        </div>

        <div class="style-selection-option-third">
          <h3 class="style-selection-title">
            <img class="public-sidebar--content-button-img" src="@/assets/img/icons/mirror.svg" alt="mirror icon" />
            Window type
          </h3>
          <div class="style-selection-title-switch">
            <span>Panoramic</span>
            <input type="checkbox" id="switch" :checked="windowType === 'standard'" @change="setWindowType($event.target.checked ? 'standard' : 'panoramic')" />
            <label for="switch"></label>
            <span>Standard</span>
          </div>
        </div>
      </div>
    </div>
    <div class="order-modal-buttons">
      <button class="order-modal-button order-modal-button-second" @click="openPrevStep">Back</button>
      <button
        :class="{
          'btn-ai-basic btn-form-setup-basic': tariff === 1,
          'btn-ai-plus btn-form-setup-plus': tariff === 2,
          'btn-ai-pro btn-form-setup-pro': tariff === 3,
          'btn-ai-render btn-form-setup-render': tariff === 4,
          'btn-ai-max btn-form-setup-max': tariff === 6,
        }"
        class="order-modal-button"
        @click="next">
        Next
      </button>
    </div>
  </div>
</template>

<script>
import CustomSelect from '@/Components/En/Common/CustomSelect.vue';
import { styles } from '@/enums/styles';
import { views } from '@/enums/views';

export default {
  name: 'StyleSelection',
  components: {
    CustomSelect,
  },
  props: {
    tariff: {
      default: 1,
      type: Number,
    },
    defaults: {
      default: () => {},
      type: Object,
    },
    openNextStep: {
      default: () => null,
      type: Function,
    },
    openPrevStep: {
      default: () => null,
      type: Function,
    },
    saveStyleAndView: {
      default: () => null,
      type: Function,
    },
  },
  data: () => ({
    style: 'scandy',
    view: 'city',
    windowType: 'standard',
    interiorStyleList: styles,
    windowViewList: views.map((item) => ({ name: item.name.en, value: item.value })),
    lang: 'en',
  }),
  mounted() {
    this.style = this.defaults.style;
    this.view = this.defaults.view;
  },
  methods: {
    isStyleActive(style) {
      return style === this.style;
    },
    isViewActive(view) {
      return view === this.view;
    },
    setView(newView) {
      this.view = newView;
    },
    setWindowType(windowType) {
      this.windowType = windowType;
    },
    setStyle(newStyle) {
    this.style = newStyle;
    },
    next() {
      this.saveStyleAndView(this.style, this.view, this.windowType);
      this.openNextStep();
    },
  },
};
</script>
